<mat-drawer-container autosize>
  <mat-card class="custom-mat-card">
    <mat-card-content class="custom-mat-card-content">
      <div id="manager_container" class="custom-container">
        <div id="manager_header" class="header-title">
          <div id="manager_contentRow" class="custom-header-row">
            <span id="manager_title" class="header-title">Account Managers</span>
            <span class="spacer"></span>
            <div id="manager_statusContent" class="status-field">
              <mat-form-field id="manager_statusField" class="dropdown">
                <mat-select
                  id="manager_statusSelect"
                  placeholder="Status"
                  multiple
                  (selectionChange)="statusSelect($event.value)">
                  @for (stat of statusList; track stat) {
                    <mat-option id="status_options" [value]="stat">
                      {{ stat }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div id="manager_search_div" class="search-field">
              <mat-form-field id="searchField" class="search-input-holder">
                <input
                  id="manager_search_input"
                  placeholder="Search..."
                  matInput
                  class="search-input"
                  autocomplete="off"
                  (keyup)="searchTable($event.target.value)" />
              </mat-form-field>
            </div>
            <button
              id="manager_add_user"
              class="add-button"
              mat-button
              routerLink="/managers/create">
              Acc. Manager<i class="fal fa-plus add-button-icon margin-left-10"></i>
            </button>
          </div>
        </div>
        <mat-table
          id="manager_table"
          class="custom-table"
          matSort
          matSortActive="firstName"
          matSortDirection="asc"
          matSortDisableClear
          [dataSource]="sortedData()"
          (matSortChange)="selectSort($event)">
          <ng-container matColumnDef="firstName">
            <mat-header-cell
              id="manager_table_first_name"
              mat-sort-header
              class="name-column"
              *matHeaderCellDef>
              <span class="custom-header pointer" id="manager_first_name_text">First Name</span>
            </mat-header-cell>
            <mat-cell id="first_name_cell" class="name-column" *matCellDef="let element">
              <span id="first_name_element">{{ element.firstName }}</span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="lastName">
            <mat-header-cell
              id="manager_table_last_name"
              mat-sort-header
              class="name-column"
              *matHeaderCellDef>
              <span class="custom-header pointer" id="manager_last_name_text">Last Name</span>
            </mat-header-cell>
            <mat-cell id="manager_last_name_cell" class="name-column" *matCellDef="let element">
              <span id="manager_last_name_element">{{ element.lastName }}</span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="email">
            <mat-header-cell
              id="manager_table_email"
              mat-sort-header
              class="email-column"
              *matHeaderCellDef>
              <span class="custom-header pointer" id="manager_table_email_text">Email</span>
            </mat-header-cell>
            <mat-cell id="manager_table_email" class="email-column" *matCellDef="let element">
              <span class="truncate" id="manager_table_first_element">{{ element.email }}</span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="lastLogin">
            <mat-header-cell
              id="manager_table_last_login"
              mat-sort-header
              class="last-login-column"
              *matHeaderCellDef>
              <span id="manager_table_last_login_header" class="custom-header pointer"
                >Last Login</span
              >
            </mat-header-cell>
            <mat-cell
              id="manager_table_last_login_cell"
              class="last-login-column"
              *matCellDef="let element">
              <span
                matTooltip="{{ element.lastLoginDate | date: 'MMM d yyyy, HH:mm' }}"
                class="default-cursor"
                matTooltipClass="custom-tooltip"
                [matTooltipShowDelay]="250">
                <span id="manager_table_created_element">
                  {{ element.lastLoginDisplay }}
                </span>
              </span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="status">
            <mat-header-cell
              id="manager_table_status"
              class="just-center status-column"
              mat-sort-header
              *matHeaderCellDef>
              <span class="custom-header pointer" id="manager_table_status_header">Status</span>
            </mat-header-cell>
            <mat-cell
              id="manager_table_status_header_cell"
              class="just-center status-column"
              *matCellDef="let element">
              <div
                class="{{
                  element.enabled === true ? 'active-status' : 'inactive-status'
                }} common-status"
                align="center">
                <span
                  class="{{
                    element.enabled === true ? 'active-status-text' : 'inactive-status-text'
                  }}"
                  id="manager_table_status_element"
                  align="center">
                  {{ element.enabled === true ? 'Enabled' : 'Disabled' }}
                </span>
              </div>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="customers">
            <mat-header-cell id="manager_table_customer_list" class="list-column" *matHeaderCellDef>
              <span class="custom-header pointer" id="manager_table_customer_list_header"
                >Customer Access</span
              >
            </mat-header-cell>
            <mat-cell
              id="manager_table_customer_list_cell"
              class="list-column"
              *matCellDef="let element">
              @if (allCustomers().size !== element.customers.length) {
                <span
                  matTooltip="{{ element.customers.join('\n') }}"
                  class="default-cursor truncate"
                  matTooltipClass="custom-tooltip"
                  [matTooltipShowDelay]="250">
                  @for (cus of element.customers; track cus; let i = $index) {
                    <span id="manager_table_customer_list_element" class="customer-list">
                      {{ cus }}
                      @if (i !== element.customers.length - 1) {
                        <span>,</span>
                      }
                    </span>
                  }
                </span>
              } @else {
                <span id="all_customers" class="customer-list"> All Customers </span>
              }
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="edit">
            <mat-header-cell
              id="manager_table_actions"
              class="just-center actions-column"
              *matHeaderCellDef>
              <span id="manager_table_actions_header" class="custom-header">Actions </span>
            </mat-header-cell>
            <mat-cell
              id="manager_table_actions_cell"
              class="just-center actions-column"
              *matCellDef="let element">
              <button
                mat-button
                id="manager_table_edit"
                class="action-button white-button"
                (click)="editManager(element)">
                Edit
              </button>
            </mat-cell>
          </ng-container>
          <mat-header-row
            id="manager_mat_header_row"
            *matHeaderRowDef="displayedColumns; sticky: true">
          </mat-header-row>
          <mat-row id="manager_mat_row" *matRowDef="let row; columns: displayedColumns"> </mat-row>
        </mat-table>
        @if (resultsLength() > 0) {
          <mat-paginator
            #paginator
            id="manager_paginator"
            class="custom-mat-paginator"
            [length]="resultsLength()"
            [pageIndex]="pageIndex()"
            [pageSize]="50"
            [pageSizeOptions]="[50, 100, 250]"
            (page)="handlePageEvent($event)">
          </mat-paginator>
        }
        <div class="no-record">
          @if (resultsLength() === 0 && loading() === false && error() === false) {
            <div id="no_data" class="no-data">
              <img
                id="manager_noDataImage"
                src="/assets/images/no_data.svg"
                alt="No Record"
                width="100" />
              <h1 id="manager_noDataText">No Data</h1>
              <p id="manager_noDataContent" class="custom-p">Let's get started shall we?</p>
            </div>
          }
          @if (error() === true) {
            <app-form-error />
          }
          @if (loading()) {
            <app-loading-spinner />
          }
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</mat-drawer-container>
